var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2017 49.5C39.6281 49.5 49.7017 39.4264 49.7017 27C49.7017 14.5736 39.6281 4.5 27.2017 4.5C14.7753 4.5 4.70166 14.5736 4.70166 27C4.70166 39.4264 14.7753 49.5 27.2017 49.5Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.194 20.4028C24.9447 17.7732 21.1939 17.0658 18.3757 19.4738C15.5575 21.8817 15.1607 25.9076 17.3739 28.7555C18.7914 30.5795 22.4217 33.962 24.8487 36.1583C25.6552 36.8882 26.0585 37.2531 26.5415 37.3994C26.9567 37.5253 27.4312 37.5253 27.8464 37.3994C28.3295 37.2531 28.7327 36.8882 29.5392 36.1583C31.9662 33.962 35.5965 30.5795 37.014 28.7555C39.2272 25.9076 38.8788 21.8564 36.0122 19.4738C33.1456 17.0912 29.4432 17.7732 27.194 20.4028Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanning);
export default __webpack_public_path__ + "static/media/CarePlanning.fba55c7d5198123b5abaf284f04ddfc0.svg";
export { ForwardRef as ReactComponent };